import { DateSegment } from "react-aria-components";
import { ComponentProps } from "react";
import { formatInTimeZone } from "date-fns-tz";
import { ZonedDateTime } from "@internationalized/date";

type CustomDateSegmentProps = {
  segment: ComponentProps<typeof DateSegment>["segment"];
  value: ZonedDateTime;
};

const CustomDateSegment = ({ segment, value }: CustomDateSegmentProps) => {
  if (segment.type === "timeZoneName") {
    // To unify the timezone display with the one in the datepicker
    return (
      <span data-type={segment.type}>
        {formatInTimeZone(value.toDate(), value.timeZone, "zzz")}
      </span>
    );
  }

  return <DateSegment segment={segment} />;
};

CustomDateSegment.displayName = "DS.CustomDateSegment";

export default CustomDateSegment;
